import posthog from 'posthog-js'

import { get as getConfig } from 'config'

// Targeted session replay for account-creation / registration flows.
//
// Recording never starts during general browsing: the PostHogProvider
// hard-disables session recording at init, and recording is started explicitly
// here when a user enters a registration flow (or opens the sign-up dialog).
// Once started, recording persists for the rest of the session, including any
// browsing after the funnel — see startRegistrationRecording below.

// Route prefixes that make up the candidate + employer registration funnels.
export const REGISTRATION_ROUTE_PREFIXES = [
  '/register',
  '/onboarding',
  '/create_password',
  '/resend_confirmation_link',
  '/candidate/email_confirmation_prompt',
  '/pending-approval',
]

// Segment-safe prefix match: '/register' matches '/register' and
// '/register/physicians' but not '/registered-nurses'.
export const isRegistrationRoute = pathname =>
  REGISTRATION_ROUTE_PREFIXES.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  )

// Begin recording the current session. Safe to call repeatedly.
//
// Recording persists for the rest of the session once started; posthog.reset()
// on logout starts a fresh session, so each flow entry re-triggers this.
export const startRegistrationRecording = () => {
  // Env gate keeps local dev fully dark; only dev/prod opt in.
  if (!getConfig('posthogEnableSessionReplay', false)) {
    return
  }

  // Avoid duplicate starts within the same session.
  if (posthog.sessionRecordingStarted()) {
    return
  }

  posthog.startSessionRecording()
}
